module.exports = __webpack_public_path__ + "img/yingguo.4a642488.png";